import UniversalHeader from "./UniversalHeader";

const StudentHeader = () => {
 
  return (
    <>
     <UniversalHeader />
    </>
  );
};

export default StudentHeader;
